import React, {createContext, useContext} from 'react'

import {AppConfig} from './types'

type Props = {
  config: AppConfig
}

const ConfigContext = createContext<AppConfig | null>(null)

const ConfigProvider: React.FC<React.PropsWithChildren<Props>> = ({config, children}) => {
  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
}

export const useConfig = (): AppConfig => {
  const contextValue = useContext(ConfigContext)

  if (contextValue === null) {
    throw new Error('missing ConfigProvider')
  }

  return contextValue
}

export default ConfigProvider
